var _rect, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPositivo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "#00A377"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_301_983",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 23,
    width: 30,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8786 31.0558L37.2653 23.6692C38.0386 22.8825 39.292 22.8825 40.0786 23.6558C40.5586 24.1358 40.7586 24.8158 40.6253 25.4825L39.3586 31.5892H46.892C49.7586 31.5892 51.692 34.5225 50.572 37.1625L46.2253 47.3092C45.7986 48.2825 44.8386 48.9225 43.772 48.9225H31.772C30.3053 48.9225 29.1053 47.7225 29.1053 46.2558V32.9358C29.1053 32.2292 29.3853 31.5492 29.8786 31.0558ZM26.4386 46.2558C26.4386 47.7225 25.2386 48.9225 23.772 48.9225C22.3053 48.9225 21.1053 47.7225 21.1053 46.2558V35.5892C21.1053 34.1225 22.3053 32.9225 23.772 32.9225C25.2386 32.9225 26.4386 34.1225 26.4386 35.5892V46.2558Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_301_983)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 32,
    height: 32,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositivo);
export default __webpack_public_path__ + "static/media/Positivo.9cfcccba11f58d7aeeadddd9316b6342.svg";
export { ForwardRef as ReactComponent };